import { Text, XStack, YStack } from "tamagui";
import { kiosk } from "../kioskTheme";
import { Card, SectionLabel } from "./ConfirmParts";

export interface CylinderUsage {
  has: boolean | null; // 家中有沒有瓦斯桶
  qty: number; // 幾桶
  usage: "home" | "biz" | null; // 用途
}
export const cylinderUsageValid = (v: CylinderUsage) => v.has === false || (v.has === true && v.usage !== null);

const Btn = ({ active, onPress, children }: { active?: boolean; onPress: () => void; children: React.ReactNode }) => (
  <YStack flex={1} ai="center" jc="center" height={46} borderRadius={12} cursor="pointer" onPress={onPress} backgroundColor={active ? "#EFF6FF" : "#fff"} borderWidth={1.5} borderColor={active ? kiosk.blue : kiosk.line} pressStyle={{ opacity: 0.9 }}>
    <Text fontSize={14} fontWeight="800" color={active ? kiosk.blue : kiosk.ink}>{children}</Text>
  </YStack>
);

/** 家中鋼瓶數量+用途（新客戶）：隨時可修改；填妥（有→選桶數/用途；沒有）才可下單。 */
const CylinderUsageCard = ({ value, onChange }: { value: CylinderUsage; onChange: (v: CylinderUsage) => void }) => {
  const set = (patch: Partial<CylinderUsage>) => onChange({ ...value, ...patch });
  return (
    <>
      <SectionLabel>家中鋼瓶數量與用途</SectionLabel>
      <Card>
        <YStack py={4} gap={16}>
          <YStack gap={8}>
            <Text fontSize={13} fontWeight="700" color={kiosk.ink}>家中目前有瓦斯桶嗎？</Text>
            <XStack gap={10}>
              <Btn active={value.has === true} onPress={() => set({ has: true })}>有</Btn>
              <Btn active={value.has === false} onPress={() => set({ has: false, usage: null })}>沒有</Btn>
            </XStack>
          </YStack>

          {value.has === true && (
            <>
              <YStack gap={8}>
                <Text fontSize={13} fontWeight="700" color={kiosk.ink}>鋼瓶數量</Text>
                <XStack ai="center" gap={16}>
                  <YStack ai="center" jc="center" width={44} height={44} borderRadius={12} borderWidth={1.5} borderColor={kiosk.line} cursor="pointer" onPress={() => set({ qty: Math.max(1, value.qty - 1) })}>
                    <Text fontSize={20} fontWeight="800" color={kiosk.ink}>−</Text>
                  </YStack>
                  <Text fontSize={18} fontWeight="800" color={kiosk.ink} width={28} textAlign="center">{value.qty}</Text>
                  <YStack ai="center" jc="center" width={44} height={44} borderRadius={12} borderWidth={1.5} borderColor={kiosk.line} cursor="pointer" onPress={() => set({ qty: Math.min(20, value.qty + 1) })}>
                    <Text fontSize={20} fontWeight="800" color={kiosk.ink}>＋</Text>
                  </YStack>
                </XStack>
              </YStack>

              <YStack gap={8}>
                <Text fontSize={13} fontWeight="700" color={kiosk.ink}>用途</Text>
                <XStack gap={10}>
                  <Btn active={value.usage === "home"} onPress={() => set({ usage: "home" })}>住家</Btn>
                  <Btn active={value.usage === "biz"} onPress={() => set({ usage: "biz" })}>營業</Btn>
                </XStack>
              </YStack>
            </>
          )}

          {!cylinderUsageValid(value) && <Text fontSize={12} color={kiosk.danger}>請完成上方選項後即可下單</Text>}
        </YStack>
      </Card>
    </>
  );
};

export default CylinderUsageCard;
